import { observable, computed, action, makeObservable } from 'mobx'
import { router } from '../App.js'

class LayoutStore {
    @observable modals = new Map()
    @observable showSidebar = false
    @observable pageRendered = false
    constructor(props) {
        makeObservable(this)
    }
    @action.bound
    toggleSidebar(setSidebar) {
        this.showSidebar = setSidebar ?? !this.showSidebar
    }
    @computed
    get displayedModals() {
        return this.modals.values()
    }
    openModal(modal) {
        if (!this.modals.has(modal.props.modalId)) {
            this.modals.set(modal.props.modalId, modal)
        }
    }
    closeModal(modalId) {
        this.modals.delete(modalId)
        // Update URL using history.replaceState to avoid TanStack Router navigation side effects
        try {
            const currentUrl = new URL(window.location.href)
            if (currentUrl.searchParams.has('modal')) {
                currentUrl.searchParams.delete('modal')
                history.replaceState({}, '', currentUrl.toString())
            }
        } catch (e) {
            console.error('Error updating URL:', e)
        }
    }
}

export default new LayoutStore()
